import React, { useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useGame } from "@/context/GameContext";
import { RIVAL } from "@/data/gameData";
import Avatar from "@/components/avatar/Avatar";
import { Sound } from "@/lib/sound";

const WeekResultModal = () => {
  const { state, markWeekSeen, triggerConfetti } = useGame();
  const r = state.lastWeekResult;
  const open = !!r && !r.seen;

  useEffect(() => {
    if (open) {
      if (r.won) { Sound.fanfare(); triggerConfetti(); } else Sound.error();
    }
  }, [open]); // eslint-disable-line

  if (!r) return null;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && markWeekSeen()}>
      <DialogContent className="max-w-md rounded-3xl border-4 border-amber-400 bg-white p-0 overflow-hidden" data-testid="week-result-modal">
        <div className={`p-6 text-center text-white ${r.won ? "bg-gradient-to-br from-amber-300 to-orange-500" : "bg-gradient-to-br from-slate-400 to-slate-600"}`}>
          <div className="text-6xl mb-1 animate-bounce-slow">{r.won ? "🏆" : "🤝"}</div>
          <div className="text-[10px] font-black uppercase tracking-[0.3em] opacity-90">Week {r.week} results</div>
          <h2 className="font-display text-3xl font-bold" data-testid="week-result-title">
            {r.won ? "You're the Top Boss!" : `${RIVAL.name} won this week`}
          </h2>
        </div>
        <div className="p-5 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="bg-emerald-50 border-2 border-emerald-200 rounded-2xl p-3 text-center">
              <Avatar avatar={state.avatar} size={48} className="mx-auto" testid="week-you-avatar" />
              <div className="text-[10px] font-black uppercase text-emerald-700 mt-1">You</div>
              <div className="font-display font-bold text-xl text-emerald-800" data-testid="week-you-total">${r.you}</div>
            </div>
            <div className="bg-orange-50 border-2 border-orange-200 rounded-2xl p-3 text-center">
              <Avatar avatar={RIVAL.avatar} size={48} className="mx-auto" testid="week-rival-avatar" />
              <div className="text-[10px] font-black uppercase text-orange-700 mt-1">{RIVAL.name}</div>
              <div className="font-display font-bold text-xl text-orange-800" data-testid="week-rival-total">${r.rival}</div>
            </div>
          </div>
          <p className="text-sm font-heading font-bold text-slate-700 text-center" data-testid="week-result-lesson">
            {r.won
              ? "Fair prices + great service = loyal customers. That's how real businesses win!"
              : `Riley grabbed ${r.stolen} of your customers. Keep prices close to the suggested price and earn 5-star ratings to win next week!`}
          </p>
          <Button onClick={() => { Sound.click(); markWeekSeen(); }} data-testid="week-result-close" className="w-full bg-amber-400 hover:bg-amber-500 text-slate-900 font-heading font-black rounded-2xl btn-3d border-2 border-amber-500 py-5">
            {r.won ? "Collect trophy →" : "Start a new week →"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WeekResultModal;
